import { render, staticRenderFns } from "./TY.vue?vue&type=template&id=f02335fc&scoped=true"
import script from "./TY.vue?vue&type=script&lang=js"
export * from "./TY.vue?vue&type=script&lang=js"
import style0 from "./TY.vue?vue&type=style&index=0&id=f02335fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02335fc",
  null
  
)

export default component.exports